module.exports = __webpack_public_path__ + "static/media/tssoft32_10.fe137cf9.ico";